import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';

import {
  handleSelectFrequency,
  handleSelectProduct,
  handleSelectProductSize,
  handleSelectAccessoryVal,
  handleSetProductCount,
} from '../../../store/models/cart';
import Headline from './Headline';
import BottomBar from './BottomBar';
import ExtraInfo from './ExtraInfo';
import CheckoutAside from './CheckoutAside';
import GrassSizeRadio from './GrassSizeRadio';
import AccessoryRadio from './AccessoryRadio';
import FrequencyRadio from './FrequencyRadio';
import SliderControlBar from './SliderControlBar';
import { $productsState } from '../../../store/models/products';

import styles from './styles.module.scss';

const CheckoutProceed = () => {
  const [pageNum, setPageNum] = useState<1 | 2 | 3>(1);
  const [mainFreq, setMainFreq] = useState<'subscribe' | 'oneTime'>(
    'subscribe',
  );

  let content = null;
  const { grasses } = useUnit($productsState);

  // Reset any product/size/frequency that leaked in from another product page
  // (e.g. Catnip), so the wizard starts blank and CheckoutAside doesn't show a
  // stale price. Once the user picks a size on page 1, the grass becomes the
  // active selection.
  useEffect(() => {
    handleSelectProduct(null);
    handleSelectProductSize(null);
    handleSelectFrequency(null);
    // The tray is offered per size on page 3; start unchecked so a selection
    // from a previous run of the wizard doesn't carry over.
    handleSelectAccessoryVal(false);
    // Catnip's detail page leaves selectedProductCount at 20 globally; reset so
    // the wizard always starts a fresh single-grass selection.
    handleSetProductCount(1);
  }, []);

  switch (pageNum) {
    case 1:
      content = <GrassSizeRadio handleSelect={handleSizeOptionChange} />;
      break;
    case 2:
      content = (
        <FrequencyRadio mainFreq={mainFreq} setMainFreq={setMainFreq} />
      );
      break;
    case 3:
      content = (
        <AccessoryRadio />
      );
      break;
    default:
      content = <GrassSizeRadio handleSelect={handleSizeOptionChange} />;
      break;
  }

  function handleSizeOptionChange(event: any) {
    const { value } = event.target;
    const selectedProduct = grasses.find((pr) => pr.size === value) || null;
    handleSelectProductSize(value);
    handleSelectProduct(selectedProduct);
  }

  function handleChangeNextPage() {
    setPageNum((prev) => (prev === 3 ? 3 : ((prev + 1) as 1 | 2 | 3)));
  }

  function handleChangePrevPage() {
    setPageNum((prev) => (prev === 1 ? 1 : ((prev - 1) as 1 | 2 | 3)));
  }

  return (
    <div className={styles.checkoutProceed}>
      <Headline pageNum={pageNum} pagesCount={3} />
      <div className={styles.main}>
        <div className={styles.leftSide}>
          <div className={styles.wrapper}>{content}</div>
          <SliderControlBar
            page={pageNum}
            changeNextPage={handleChangeNextPage}
            changePrevPage={handleChangePrevPage}
          />
          <BottomBar />
        </div>
        <div className={styles.rightSide}>
          <CheckoutAside />
          <ExtraInfo />
        </div>
      </div>
    </div>
  );
};

export default CheckoutProceed;
